const drafts = new Map();
const listeners = new Set();

const keyOf = (studentId) => Number(studentId || 0);
const notify = (studentId) => {
  const key = keyOf(studentId);
  const draft = drafts.get(key) || null;
  for (const listener of listeners) listener(key, Boolean(draft?.dirty));
};

export const getYoungApprenticeDraft = (studentId) => drafts.get(keyOf(studentId)) || null;
export const hasYoungApprenticeDraftChanges = (studentId) => Boolean(getYoungApprenticeDraft(studentId)?.dirty);

export const registerYoungApprenticeDraft = (studentId, draft) => {
  const key = keyOf(studentId);
  if (!key) return;
  drafts.set(key, { ...(draft || {}), dirty: Boolean(draft?.dirty) });
  notify(key);
};

export const clearYoungApprenticeDraft = (studentId) => {
  const key = keyOf(studentId);
  if (!key) return;
  drafts.delete(key);
  notify(key);
};

export const subscribeYoungApprenticeDraft = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const saveYoungApprenticeDraft = async (studentId) => {
  const key = keyOf(studentId);
  const draft = drafts.get(key);
  if (!draft?.dirty) return null;
  if (typeof draft.save !== 'function') throw new Error('Não foi possível salvar os dados do Jovem Aprendiz. Abra a aba e tente novamente.');
  const result = await draft.save(draft.data);
  drafts.delete(key);
  notify(key);
  return result;
};
